import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormControl, MenuItem, Select } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  // Define your styles here
  ul: {
    background: theme.palette.card.cardColor,
    color: theme?.palette?.card?.cardFontColor,
    "& ul": {
      color: theme.palette.card.cardFontColor,
      background: theme.palette.card.cardColor,
    },
  },
  selectMenu: {
    background: theme.palette.card.cardColor,
    "& li": {
      color: theme.palette.card.cardFontColor,
    },
  },
}));

function Index({
  slots,
  className,
  value,
  onChange,
  isFromCheckout = false,
  setNewChange,
}) {
  const [selectedDate, setSelectedDate] = useState({});
  const classes = useStyles();
  const { checkoutDetails } = useSelector((state) => state.cart);
  const [newDateChange, setNewDateChange] = useState(false);

  // console.log("slotssssssss", slots);
  // console.log("selected dateeeeeeee", selectedDate);

  const checkoutDate = checkoutDetails?.deliveryTime
    ? new Date(checkoutDetails.deliveryTime).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    : null;
  // useEffect(() => {

  //   if (!slots.includes(selectedDate)) {
  //     const data = slots[0];
  //     if (data) {
  //       setSelectedDate(data);
  //       onChange({ value: data.date }, "date");
  //     }

  //     return;
  //   }
  //   if (selectedDate) {
  //     onChange({ value: selectedDate.date }, "date");
  //   } else {
  //     const data = slots[0];
  //     if (data) {
  //       setSelectedDate(data);
  //       onChange({ value: data.date }, "date");
  //     }
  //   }
  // }, [selectedDate, slots]);

  // Checkout sync: react to externally-driven cart.deliveryTime changes
  // ONLY for the isFromCheckout context (the standalone checkout page).
  // For the modal popup (isFromCheckout=false/undefined), the picker is
  // self-contained — its internal selectedDate should not get re-emitted
  // every time cart.deliveryTime updates. The previous combined effect
  // re-fired the trailing "onChange(selectedDate)" branch on every
  // checkoutDate change, which silently overrode the parent's state
  // updates: e.g. clicking the ASAP radio while the picker showed
  // tomorrow → parent setDate(today) → cart dispatch → checkoutDate
  // changes → this effect re-fires → onChange("tomorrow") → parent
  // setDate(tomorrow) again → setOrderTimeType("SCHEDULED") via the
  // isFuture override → ASAP gets reverted to SCHEDULED in one beat.
  useEffect(() => {
    if (!isFromCheckout) return;
    if (!checkoutDate) return;
    if (newDateChange) return;
    const matchedSlot = slots.find((slot) => slot.date === checkoutDate);
    if (matchedSlot && matchedSlot !== selectedDate) {
      setSelectedDate(matchedSlot);
      onChange({ value: matchedSlot.date }, "date");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFromCheckout, checkoutDate, newDateChange, slots]);

  // Slot/selectedDate sync: handles the picker's own state transitions
  // (slots list updated, selectedDate not in slots, etc.). No
  // dependency on checkoutDate so external cart changes can't fire the
  // unconditional onChange re-emit and overwrite parent state.
  useEffect(() => {
    // When `selectedDate` is `{}` (initial) and `slots` has just
    // populated, this effect would normally fall back to `slots[0]`
    // (= Today). But in checkout context, Effect A above is about to
    // sync `selectedDate` with cart's `checkoutDate` (= Tomorrow or any
    // future date). React runs both effects in declaration order in
    // the SAME render cycle — Effect A's setSelectedDate hasn't applied
    // yet when this effect reads `selectedDate`, so without this guard
    // Effect B's `slots[0]` fallback overrides Effect A's Tomorrow
    // selection in the same render batch. Result: checkout time
    // section shows Today even when modal handed us Tomorrow.
    const willCheckoutSyncHandle =
      isFromCheckout &&
      checkoutDate &&
      !newDateChange &&
      slots.find((s) => s.date === checkoutDate);
    if (!slots.includes(selectedDate)) {
      if (willCheckoutSyncHandle) return;
      const data = slots[0];
      if (data) {
        setSelectedDate(data);
        onChange({ value: data.date }, "date");
      }
      return;
    }
    if (selectedDate) {
      onChange({ value: selectedDate.date }, "date");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate, slots]);

  const handleChange = () => {
    setNewDateChange(true);
    if (setNewChange) {
      setNewChange(true);
    }
  };

  return (
    <FormControl variant="outlined" className={className}>
      {/* <InputLabel id="delivery-time">Time</InputLabel> */}
      <Select
        labelId="delivery-time"
        id="delivery-date-select"
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        onClick={handleChange}
        label="Date"
        MenuProps={{
          classes: { paper: classes.selectMenu },
        }}
        className={`slotSelectorFont font-weight-bold ${classes.ul}`}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {slots.map((elem, key) => (
          <MenuItem key={`option-${key}`} value={elem}>
            {elem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

Index.defaultProps = {
  buffer: null,
};

Index.propTypes = {
  buffer: PropTypes.number,
  className: PropTypes.string.isRequired,
};

export default Index;
